var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 133,
    viewBox: "0 0 192 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.405 35.1862L82.9176 11.0273C79.1567 10.132 75.3822 12.4551 74.4869 16.216L59.5626 78.9101C58.6673 82.671 60.9903 86.4456 64.7512 87.3409L166.238 111.5C169.999 112.395 173.774 110.072 174.669 106.311L189.593 43.6169C190.489 39.856 188.166 36.0814 184.405 35.1862Z",
    fill: "#B0CECA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.184 49.5352L73.0776 22.1343L69.9546 35.2534L185.061 62.6544L188.184 49.5352Z",
    fill: "#34544F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.734 98.5385L146.846 93.09C146.773 93.0727 146.7 93.1177 146.682 93.1906L145.232 99.2819C145.215 99.3547 145.26 99.4279 145.333 99.4452L168.221 104.894C168.294 104.911 168.367 104.866 168.384 104.793L169.834 98.7018C169.852 98.629 169.807 98.5558 169.734 98.5385Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 2.27972L7.40408 42.9984C3.74889 44.2576 1.80651 48.2414 3.06567 51.8966L28.5248 125.802C29.7839 129.457 33.7678 131.399 37.423 130.14L155.625 89.4214C159.28 88.1623 161.223 84.1784 159.964 80.5232L134.504 6.61813C133.245 2.96293 129.261 1.02056 125.606 2.27972Z",
    fill: "#4E7E77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.15 11.834L109.362 16.5837C107.169 17.3392 106.004 19.7295 106.759 21.9227L111.509 35.7105C112.265 37.9036 114.655 39.069 116.848 38.3135L130.636 33.5639C132.829 32.8084 133.994 30.418 133.239 28.2249L128.489 14.4371C127.734 12.244 125.343 11.0785 123.15 11.834Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8582 77.9108L28.9962 93.7096C28.8648 93.7548 28.795 93.898 28.8402 94.0294L31.1763 100.811C31.2215 100.942 31.3647 101.012 31.4961 100.967L77.3581 85.1678C77.4895 85.1226 77.5593 84.9794 77.514 84.848L75.178 78.0668C75.1327 77.9354 74.9895 77.8656 74.8582 77.9108Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2754 85.1744L33.8225 107.722C33.6911 107.767 33.6213 107.91 33.6665 108.042L36.0026 114.823C36.0478 114.954 36.191 115.024 36.3224 114.979L101.775 92.4314C101.907 92.3861 101.976 92.2429 101.931 92.1116L99.5952 85.3303C99.5499 85.199 99.4067 85.1292 99.2754 85.1744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.eb044ae7503ef4972470c520c8a32209.svg";
export { ForwardRef as ReactComponent };